export const contractAddress = process.env.REACT_APP_BigShortAlphaFactoryAddress;
export const USDCAddress = process.env.REACT_APP_USDC_Address;
